'use strict';

productOverviewService.$inject = ["productService", "ProductOverview", "ProductSearchRequest", "ProductFilterRequest", "Filter", "common", "Enums", "FilterCategory", "$stateParams", "$q", "$state", "categoryService", "sellerService", "gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productOverviewService = productOverviewService;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productOverviewService(productService, ProductOverview, ProductSearchRequest, ProductFilterRequest, Filter, common, Enums, FilterCategory, $stateParams, $q, $state, categoryService, sellerService, gettextCatalog) {
    return {
        init: init,
        loadProducts: loadProducts,
        getProductsForHomepage: getProductsForHomepage,
        getProductsByDiscounts: getProductsByDiscounts,
        getProductsBySearchValue: getProductsBySearchValue,
        getProductsByBrand: getProductsByBrand,
        getProductsByCategory: getProductsByCategory,
        getDiscountsBySeller: getDiscountsBySeller,
        getSellerProducts: getSellerProducts,
        getSellerDiscounts: getSellerDiscounts,
        getProductsBySellerCategory: getProductsBySellerCategory,
        getSellerDetailDiscounts: getSellerDetailDiscounts,
        getSellerDetailProducts: getSellerDetailProducts,
        getProductSliderSettings: getProductSliderSettings,
        getOutletProducts: getOutletProducts,
        setProductOverviewModel: setProductOverviewModel,
        getProductOverviewModel: getProductOverviewModel,
        getCustomCategory: getCustomCategory
    };

    function init(context) {
        return ProductOverview.create(context);
    }
    function getCustomCategory() {
        var cat = FilterCategory.create({
            id: '0',
            name: 'Special Discounts',
            isHierarchical: false,
            isCollapsed: false,
            isLink: true,
            isSellerCategory: false,
            initialLimit: 15,
            limit: 15,
            items: [{ id: 0,
                name: 'Black Friday',
                parentCategoryId: null,
                parents: [],
                isSelected: $stateParams.filter.indexOf('10_0') !== -1
            }],
            context: 10,
            order: 0
        });
        return cat;
    }
    function loadProducts(init, loadFilter, model, searchRequest, filterRequest, page, outlet) {
        var promises = [];

        if (outlet) {
            promises.push(productService.getByCriteriaForOutlet(searchRequest));
        } else if (filterRequest.SellerId) {
            promises.push(productService.getByCriteria(searchRequest));
            promises.push(loadFilter ? productService.getFilter(filterRequest) : $q.when(null));
            promises.push(categoryService.getById($stateParams.categoryId));
            promises.push(sellerService.getSellerTotalPriceDiscounts($stateParams.sellerId));
        } else {
            promises.push(productService.getByCriteria(searchRequest));
            promises.push(loadFilter ? productService.getFilter(filterRequest) : $q.when(null));
            promises.push(categoryService.getById($stateParams.categoryId));
        }

        model.errorOccurred = false;
        model.isLoadingInitial = init;
        model.isLoading = true;

        //TODO: when query string filter param is available and init, then get products without filter and with filter 
        return $q.all(promises).then(function (promiseResults) {
            var productsResult = promiseResults[0];
            var filtersResult = promiseResults[1];
            var categoryResult = promiseResults[2];
            var totalPriceDiscounts = promiseResults[3];
            var test = (0, _moment2.default)().isSame('2018-11-23', 'day');
            if (searchRequest.context === Enums.searchContext.discount.id && filtersResult && filtersResult.filterCategories && test) {
                filtersResult.filterCategories.unshift(getCustomCategory());
            }
            model.paging.totalItems = productsResult.totalItems;
            model.paging.page = page;
            model.products = productsResult.products;
            model.category = categoryResult === null ? { name: gettextCatalog.getString('All products') } : categoryResult;
            model.totalPriceDiscounts = totalPriceDiscounts;
            if (filtersResult) {
                model.filter = filtersResult;
            }

            model.paging.update(page);
            if (model.filter) {
                model.filter.markFilterCheckboxesAsSelected($stateParams.filter);
                model.filter.setSelectedFilters($stateParams.filter);
            }

            if (model.products.length > 0) {
                model.productsAvailableForContext = true;
            }

            model.productsAvailableForCriteria = model.products.length > 0;
            model.isLoadingInitial = false;
            model.isLoading = false;
            return model;
        }).catch(function () {
            model.isLoadingInitial = false;
            model.isLoading = false;
            model.errorOccurred = true;
            return model;
        });
    }

    function getQueryStringParams(productOverviewModel, defaultSortProperty) {
        var page = parseInt($stateParams.page);
        var pageSize = parseInt(window.sessionStorage.getItem('pageSize')) || parseInt($stateParams.pageSize);
        var sortByField = null;
        var sortAsc = null;
        //set sorting and check localstorage     
        if (window.localStorage.getItem($state.current.name + '-sortProperty')) {
            sortByField = window.localStorage.getItem($state.current.name + '-sortProperty');
        } else {
            sortByField = $stateParams.sortProperty || defaultSortProperty;
        }

        if (window.localStorage.getItem($state.current.name + '-sortAsc')) {
            sortAsc = window.localStorage.getItem($state.current.name + '-sortAsc');
        } else {
            sortAsc = $stateParams.sortAsc;
        }

        return {
            page: page,
            skip: productOverviewModel.paging.getSkipValue(page, pageSize),
            take: pageSize,
            sortByField: sortByField,
            sortAsc: sortAsc,
            filter: $stateParams.filter
        };
    }

    function getProductsForHomepage(init, productOverviewModel) {
        common.log.info('getProductsForHomepage');
        var searchRequest = ProductSearchRequest.createForHomePage();
        var filterRequest = ProductFilterRequest.createForHomePage();
        return loadProducts(init, false, productOverviewModel, searchRequest, filterRequest, 0);
    }

    function getProductsByDiscounts(init, productOverviewModel, discountTypeId) {
        common.log.info('getProductsByDiscounts');
        var params = getQueryStringParams(productOverviewModel, 'DiscountDate');
        var searchRequest = ProductSearchRequest.createForDiscounts(params, discountTypeId);
        var filterRequest = ProductFilterRequest.createForDiscounts(discountTypeId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getProductsBySearchValue(init, productOverviewModel, searchValue) {
        common.log.info('getProductsBySearchValue');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForSearch(params, searchValue);
        var filterRequest = ProductFilterRequest.createForSearch(searchValue);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getProductsByBrand(init, productOverviewModel, brandId) {
        common.log.info('getProductsByBrand');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForBrand(params, brandId);
        var filterRequest = ProductFilterRequest.createForBrand(brandId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getProductsByCategory(init, productOverviewModel, categoryId) {
        common.log.info('getProductsByCategory');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForCategory(params, categoryId);
        var filterRequest = ProductFilterRequest.createForCategory(categoryId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getDiscountsBySeller(init, productOverviewModel, sellerId) {
        common.log.info('getDiscountsBySeller');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForSeller(params, sellerId);
        var filterRequest = ProductFilterRequest.createForSeller(sellerId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getOutletProducts(init, productOverviewModel, sellerId, categoryId) {
        common.log.info('getSellerProducts');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForSellerProducts(params, sellerId, categoryId);
        var filterRequest = ProductFilterRequest.createForSellerProducts(sellerId, categoryId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page, true);
    }

    function getSellerProducts(init, productOverviewModel, sellerId, categoryId) {
        common.log.info('getSellerProducts');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForSellerProducts(params, sellerId, categoryId);
        var filterRequest = ProductFilterRequest.createForSellerProducts(sellerId, categoryId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getSellerDiscounts(init, productOverviewModel, sellerId) {
        common.log.info('getSellerDiscounts');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForSellerDiscounts(params, sellerId);
        var filterRequest = ProductFilterRequest.createForSellerDiscounts(sellerId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getProductsBySellerCategory(init, productOverviewModel, sellerId, sellerCategoryId) {
        common.log.info('getProductsBySellerCategory');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForSellerCategory(params, sellerId, sellerCategoryId);
        var filterRequest = ProductFilterRequest.createForSellerCategory(sellerId, sellerCategoryId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getSellerDetailDiscounts(init, productOverviewModel, sellerId) {
        common.log.info('getSellerDetailDiscounts');
        var searchRequest = ProductSearchRequest.createForSellerDetailDiscounts(sellerId);
        var filterRequest = ProductFilterRequest.createForSellerDetailDiscounts(sellerId);
        return loadProducts(init, false, productOverviewModel, searchRequest, filterRequest, 0);
    }

    function getSellerDetailProducts(init, productOverviewModel, sellerId) {
        common.log.info('getSellerDetailProducts');
        var searchRequest = ProductSearchRequest.createForSellerDetailProducts(sellerId);
        var filterRequest = ProductFilterRequest.createForSellerDetailDiscounts(sellerId);
        return loadProducts(init, false, productOverviewModel, searchRequest, filterRequest, 0);
    }

    function getProductSliderSettings() {
        return Enums.productSliderSettings;
    }

    function setProductOverviewModel(productOverviewModel) {
        this.productOverviewModel = productOverviewModel;
    }

    function getProductOverviewModel() {
        return this.productOverviewModel;
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/productOverviewService.js
// module id = 823
// module chunks = 0